<div class="maquininhas-page">
  <app-banner-typec
    [img]="'parcial.png'"
    [title]="'Com a azulzinha, maquininha da CAIXA, você pode muito mais!'"
    [description]="'Conheça as nossas opções de aluguel.'"
    [cta]="'Saiba mais'"
    [url]="'/maquininhas#dobra'"
    [className]="['justify-content-start', 'align-items-center', 'text-end']"
    [shouldChangeTheDirectionOfTheAnimation]="true"
  />
  <section id="dobra" class="video-main">
    <div class="container">
      <header>
        <h2>Para ter uma solução móvel completa</h2>
        <p class="mt-4">
          Ela é azulzinha porque é da CAIXA! Conheça as vantagens que só a
          maquininha da CAIXA pode oferecer para você.<br />
          Assista ao vídeo:
        </p>
      </header>
      <div class="container-video mt-5">
        <div
          (click)="onNavigation('azulzinha-maquininha-caixa', 'clicou')"
          class="video"
        >
          <video
            poster="assets/img/chegou-azulzinha.png"
            controls
            controlsList="nodownload"
          >
            <source
              src="{{ env.origin }}/midias/chegou-azulzinha.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
    </div>
  </section>
  <section class="seu-negocio">
    <div class="container">
      <header>
        <h2>A azulzinha ideal para o seu negócio está aqui</h2>
        <p class="mt-4 mb-5">
          Todos os modelos de azulzinha já vêm com uma grande rede de aceitação
          de bandeiras, meios de pagamento e serviços adicionais, tudo sempre
          atualizado para você aperfeiçoar a experiência do seu cliente,
          aumentar suas vendas e cuidar da saúde do caixa.
        </p>
      </header>
      <div class="row">
        <div class="col">
          <p>
            <img
              class="img-negocios"
              [lazyLoad]="'assets/img/transacoes.png'"
              alt=""
            />
          </p>
          <p>Taxas competitivas</p>
        </div>
        <div class="col">
          <p>
            <img
              class="img-negocios"
              [lazyLoad]="'assets/img/crediario.png'"
              alt=""
            />
          </p>
          <p>Venda no crediário</p>
        </div>
        <div class="col">
          <p>
            <img
              class="img-negocios"
              [lazyLoad]="'assets/img/pix-gray.png'"
              alt=""
            />
          </p>
          <p>Aceita a modalidade Pix</p>
        </div>
        <div class="col">
          <p>
            <img
              class="img-negocios"
              [lazyLoad]="'assets/img/icons/simples-acesso.png'"
              alt=""
            />
          </p>
          <p>Gestão de vendas no aplicativo</p>
        </div>
        <div class="text-center mt-5">
          <a class="btn btn-primary" href="maquininhas#ancora"
            >Conheça os modelos</a
          >
        </div>
      </div>
    </div>
  </section>
  <section class="bandeiras">
    <div class="container">
      <h2>Já vem com a mais variada rede de bandeiras e carteiras digitais</h2>
      <app-bandeiras></app-bandeiras>
    </div>
  </section>
  <div class="section-clover">
    <div class="container">
      <div class="row row-reverse align-items-center d-flex">
        <div class="col-xs-12 col-sm-12 col-md-6 col-12">
          <div class="centered-item">
            <div class="centered">
              <div class="titulo text-black">
                <p class="gray">
                  <strong
                    >Para atender no balcão, na mesa ou em qualquer
                    lugar</strong
                  >
                </p>
                <h2>Clover Flex</h2>
                <h5 class="d-flex flex-column mt-4">
                  <div>
                    <span class="d-flex gap-1">
                      <span>-</span>Tudo em um só dispositivo: faça pedidos, receba pagamentos e gerencie
                      seu negócio em um só lugar;
                    </span>
                  </div>
                  <div>
                    <span
                     class="d-flex gap-1"
                      ><span>- </span>Mobilidade: elimine filas e aceite pagamentos no
                      balcão, na mesa ou em qualquer lugar;</span
                    >
                  </div>
                  <div>
                    <span class="d-flex gap-1"
                      ><span>-</span> Praticidade: conecte-se a outros dispositivos Clover e
                      integre novas aplicações sempre que precisar.
                    </span>
                  </div>
                </h5>

                <div class="content-manual gap-2">
                  <div>
                    <a
                      routerLink="/clover"
                      class="btn btn-primary btn-big mt-3"
                    >
                      Saiba mais
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-12 box-img">
          <picture>
            <img
              style="padding-top: 2rem"
              class="mx-100"
              [lazyLoad]="'/assets/img/maquinas/clover/flex.png'"
            />
          </picture>
        </div>
      </div>
    </div>
  </div>

  <div class="section-pinpad">
    <div class="container">
      <div class="row row-reverse column-reverse align-items-center">
        <div class="col-xs-12 col-sm-12 col-md-6 col-12 box-img">
          <picture>
            <img
              style="padding-top: 2rem"
              class="mx-100"
              [lazyLoad]="'assets/img/maquinas/clover/mini.png'"
            />
          </picture>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-12">
          <div class="centered-item">
            <div class="centered">
              <div class="titulo text-black">
                <p class="gray">
                  <strong>Para ter um PDV perfeito para qualquer espaço</strong>
                </p>
                <h2 class="mt-4">Clover Mini</h2>
                <h5 class="mt-4">
                  <span class="d-flex gap-1"
                    ><span>-</span> Tela touch: tela de 8” sensível ao toque para autoatendimento e conferência da compra;</span
                  >
                  <span class="d-flex gap-1"
                    ><span>-</span> Pagamentos simplificados: entrada para cartão e
                    contactless na parte frontal para mais praticidade;</span
                  >
                  <span class="gap-1 d-flex"
                    ><span>-</span> Impressora integrada: emissão imediata de comprovantes
                    impressos ou envio por e-mail e SMS.</span
                  >
                </h5>
                <div class="content-manual gap-2">
                  <div>
                    <a
                      routerLink="/clover"
                      class="btn btn-primary btn-big mt-3"
                    >
                      Saiba mais
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="ancora" class="section-pos">
    <div class="container">
      <div class="row row-reverse">
        <div class="col-xs-12 col-sm-12 col-md-7 col-12">
          <div class="centered-item">
            <div class="centered">
              <div class="titulo text-black">
                <p class="gray">Para levar a maquininha até o cliente</p>
                <h2>azulzinha pro</h2>
                <h5 class="">
                  <div>
                    <span>- Pagamento por aproximação (NFC);</span>
                  </div>
                  <div><span>- Conexão Wi-Fi e 3G;</span></div>
                  <div><span>- Bateria de longa duração.</span></div>
                </h5>

                <div class="content-manual gap-2">
                  <div>
                    <a routerLink="./pro" class="btn btn-primary btn-big mt-3">
                      Saiba mais
                    </a>
                  </div>
                  <div>
                    <a
                      [routerLink]="['./pro', { param: 'manual-section' }]"
                      class="btn btn-primary btn-big mt-3 block manual mb-3"
                    >
                      <img
                        class="icon-download"
                        [lazyLoad]="'assets/img/download-solid.svg'"
                        alt=""
                      />
                      Baixe o manual
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-5 col-12 text-center box-img">
          <picture class="">
            <img
              class="celular-imagem1 mx-100"
              [lazyLoad]="'/assets/img/Maquininha3.png'"
            />
          </picture>
        </div>
      </div>
    </div>
  </div>
  <div class="section-aproxima">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-7 col-12">
          <div class="centered-item">
            <div class="centered">
              <div class="titulo text-black">
                <p class="gray">
                  Para transformar um celular ou tablet em maquininha
                </p>
                <h2>azulzinha aproxima</h2>
                <h5 class="">
                  <div>
                    <span
                      >- Venda mais e onde quiser com o App azulzinha
                      aproxima;</span
                    >
                  </div>
                  <div>
                    <span
                      >- Instale o aplicativo no seu celular ou tablet;</span
                    >
                  </div>
                  <div>
                    <span
                      >- Receba pagamentos por aproximação, Pix e carteiras
                      digitais.</span
                    >
                  </div>
                </h5>
                <div class="content-manual gap-2">
                  <div>
                    <a
                      routerLink="/azulzinha-aproxima"
                      class="btn btn-primary btn-big mt-3"
                    >
                      Saiba mais
                    </a>
                  </div>
                  <div>
                    <a
                      target="_blank"
                      href="{{
                        env.origin
                      }}/midias/manual_azulzinha_aproxima.pdf"
                      class="btn d-flex btn-primary mt-3 align-items-center manual mb-3"
                    >
                      <img
                        class="icon-download"
                        [lazyLoad]="'assets/img/download-solid.svg'"
                        alt=""
                      />
                      Baixe o manual
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 text-center col-md-5 col-12 box-img">
          <picture>
            <img
              class="celular-imagem-aproxima mx-100"
              [lazyLoad]="'/assets/img/celular-aproxima.png'"
            />
          </picture>
        </div>
      </div>
    </div>
  </div>
  <div class="section-smart">
    <div class="container">
      <div class="row row-reverse">
        <div class="col-xs-12 col-sm-12 col-md-8 col-12">
          <div class="centered-item">
            <div class="centered">
              <div class="titulo text-black">
                <p class="gray">
                  Para centralizar e simplificar a gestão financeira
                </p>
                <h2>azulzinha smart</h2>
                <h5 class="d-flex flex-column mt-4">
                  <div>
                    <span class="col-md-11 d-flex gap-0"
                      ><span>- </span>Visão consolidada com integradoras de aplicativos (Mobility, Navs, Pagzilla, Pos Controle e Smart pos);
                    </span>
                  </div>
                  <div><span>- Pagamento portátil Chip & PIN;</span></div>
                  <div><span>- Wi-Fi & Bluetooth;</span></div>
                  <div><span>- Bateria de longa duração.</span></div>
                </h5>

                <div class="content-manual gap-2">
                  <div>
                    <a
                      routerLink="/azulzinhasmart"
                      class="btn btn-primary btn-big mt-3"
                    >
                      Saiba mais
                    </a>
                  </div>
                  <div>
                    <a
                      target="_blank"
                      href="{{ env.origin }}/midias/azulzinhasmart.pdf"
                      class="btn btn-primary btn-big mt-3 block manual mb-3"
                    >
                      <img
                        class="icon-download"
                        [lazyLoad]="'assets/img/download-solid.svg'"
                        alt=""
                      />
                      Baixe o manual
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-12 box-img">
          <picture>
            <img
              class="mx-100 celular-imagem3"
              [lazyLoad]="'/assets/img/azulzinha-smart.png'"
            />
          </picture>
        </div>
      </div>
    </div>
  </div>
  <div class="section-pinpad">
    <div class="container">
      <div class="row row-reverse column-reverse">
        <div class="col-xs-12 col-sm-12 col-md-5 col-12 box-img">
          <picture>
            <img
              class="mx-100 celular-imagem2"
              [lazyLoad]="'/assets/img/lane_frontal.png'"
            />
          </picture>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-7 col-12">
          <div class="centered-item">
            <div class="centered">
              <div class="titulo text-black">
                <p class="gray">
                  Para negócios com grande volume de transações
                </p>
                <h2>azulzinha TEF</h2>
                <h5 class="">
                  <span>- Transferência eletrônica de fundos (TEF);</span><br />
                  <span>- Pagamento por aproximação (NFC);</span><br />
                  <span>- Conexão USB e Serial;</span><br />
                  <span>- Bateria de longa duração.</span>
                </h5>
                <div class="content-manual gap-2">
                  <div>
                    <a routerLink="./tef" class="btn btn-primary btn-big mt-3">
                      Saiba mais
                    </a>
                  </div>
                  <div>
                    <a
                      target="_blank"
                      href="{{
                        env.origin
                      }}/midias/LO_Manual_Azulzinha_Tef_Lane_3000_23_MARC_23_v1.pdf"
                      class="btn btn-primary btn-big mt-3 block manual"
                    >
                      <img
                        class="icon-download"
                        [lazyLoad]="'assets/img/download-solid.svg'"
                        alt=""
                      />
                      Baixe o manual
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
 

  <section class="content-novidade">
    <div class="container">
      <div class="dobra-novidade">
        <span class="title-novidade"
          ><span class="title-novidade" style="color: #ff9400"
            >Grupo Comercial</span
          >
          da azulzinha: garanta as melhores condições para os seus
          estabelecimentos</span
        >
        <p class="description px-4">
          Você tem diferentes estabelecimentos do mesmo ramo? Seu Gerente PJ
          CAIXA pode criar um
          <span style="color: #ff9400; font-weight: bold">Grupo Comercial</span>
          com todos eles e garantir as melhores taxas para os seus negócios.
        </p>

        <div class="row text-center">
          <div class="col-md-3 card-icon">
            <img [lazyLoad]="'../../../assets/img/icons/graphico.png'" alt="" />
            <p>
              Taxas mais atrativas e iguais para todos os estabelecimentos
              comerciais pertencentes ao Grupo
            </p>
          </div>
          <div class="col-md-3 card-icon">
            <img
              [lazyLoad]="'../../../assets/img/icons/maq_cartao.png'"
              alt=""
            />
            <p>Isenção da taxa de maquininha quando aplicável*</p>
          </div>
          <div class="col-md-3 card-icon">
            <img [lazyLoad]="'../../../assets/img/icons/peoples.png'" alt="" />
            <p>
              Todos os estabelecimentos comerciais participantes devem ter o
              mesmo ramo de atividade
            </p>
          </div>
        </div>
        <div class="d-flex flex-column">
          <span class="title-novidade mb-1">Fale com seu gerente PJ CAIXA</span>
          <span>para conhecer as regras e condições</span>
        </div>
        <div
          style="
            justify-content: flex-end;
            align-items: flex-end;
            display: flex;
            width: 100%;
            font-size: 14px;
          "
        >
          <span>*Verifique as condições de isenção para o seu perfil.</span>
        </div>
      </div>
    </div>
  </section>

  <section class="accordion-maquininha">
    <div class="container">
      <header class="text-center mb-4">
        <h2>Saiba tudo sobre a azulzinha</h2>
      </header>
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Existe um limite de maquininhas por pedido?
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Sim. No momento do credenciamento a solicitação é de até 05
              terminais, podendo posteriormente ser liberado até 20 equipamentos
              por estabelecimento. Acima de 20 maquininhas, é necessária uma
              avaliação.
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Existe a possibilidade de compra da maquininha ou somente aluguel?
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Neste momento, está disponível a opção aluguel.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              A maquininha precisa de celular?
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">Não, não precisa.</div>
          </div>
        </div>
      </div>
      <footer class="text-center mt-5">
        <p>
          Quer saber mais sobre os modelos, condições de contratação, entrega,
          meios de pagamento, habilitação e muito mais sobre a azulzinha?
          Confira as perguntas frequentes e a nossa galeria de vídeos.
        </p>
        <a class="btn btn-primary mt-4" href="/ajuda">Ir para ajuda</a>
      </footer>
    </div>
  </section>
  <section class="mt-5">
    <app-promotion-banner
      title="Com a azulzinha da CAIXA você pode muito mais!"
      description="Preencha o formulário e receba uma oferta personalizada para seu negócio, com as melhores taxas e condições que só a CAIXA pode oferecer para você."
      textCta="Peça já a sua azulzinha"
      hrefCta="/peca-azulzinha"
    ></app-promotion-banner>
  </section>
</div>
